export default __webpack_public_path__ + "static/media/jayant.cb6c939f.jpg";